import React, { useEffect } from "react";
import { Button, Tree, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { FormBox } from "./FormBox";
import { EventDataNode, DataNode } from "antd/lib/tree";
import { useDictModel } from "../dictModel";
import { IDictDetail } from "../dictService";

export const DataBox = () => {
    const { treeSource, loadData, setMode, setSelectedNodes, selectedNodes, setFormVal, removeOneDict, sync } = useDictModel();

    useEffect(() => {
        loadData();
    }, [])


    //字典选中事件
    const onSelect = (selectedKeys: React.Key[], info: {
        event: "select";
        selected: boolean;
        node: EventDataNode;
        selectedNodes: DataNode[];
        nativeEvent: MouseEvent;
    }) => {
        let selectNode = info.selectedNodes as IDictDetail[];
        // console.log(selectNode[0])
        setMode(info.selected ? "edit" : "");
        setSelectedNodes(selectNode);
        setFormVal({ nameEn: "", ...selectNode[0] });
    };


    const action = <>
        {treeSource.length <= 0 && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setMode("root")}
        >增加根级</Button>}
        {/* <YhAuth resCode={ResourceAuthEnum.DATA_DIC_SUB}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (!selectedNodes.length) {
                    message.warning("请选择要增加的父级");
                    return;
                }
                message.success("增加下级模式开启");
                setMode("nextAdd");
            }}
        >增加下级</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.DATA_DIC_BRO}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (!selectedNodes.length) {
                    message.warning("请选择要增加的同级");
                    return;
                }
                message.success("增加同级模式开启");
                setMode("add");
            }}
        >增加同级</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.DATA_DIC_SYNC}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => sync()}
        >同步</Button>
        {/* </YhAuth> */}
        {/* {treeSource.length > 0 && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedNodes.length && selectedNodes[0].children.length) { 
                    message.warning("请选择要删除的节点并且子节点为空");
                    return;
                }
                removeOneDict(selectedNodes[0].code);
            }}
        >删除</Button>} */}
    </>;

    return (
        <YhBox title="" action={action}>
            <div className="dict-container flex">
                <div className="dict-list-box">
                    <Tree
                        defaultExpandedKeys={[selectedNodes[0]?.key]}
                        selectedKeys={[selectedNodes[0]?.key]}
                        titleRender={(node: any) => `${node.name}`}
                        onSelect={onSelect}
                        treeData={treeSource}
                    />
                </div>
                <div className="dict-from-box flex">
                    {selectedNodes.length > 0 ?
                        <FormBox />
                        :
                        <div className="dict-init-box flex flex-1 items-center justify-center">数据字典</div>
                    }
                </div>
            </div>
        </YhBox>
    )
}